import { mapkeysConstants } from '../_constants'
import { mapkeysService } from '../_services'
import { alertActions } from '../_actions'
export const mapkeysActions = {
  getAllMapKeys,
  updateMapkeys
}

function getAllMapKeys() {
  return dispatch => {
    dispatch(request())

    mapkeysService.getAllMapkeys()
      .then(
        mapkeys => {
          console.log(mapkeys)
          dispatch(success(mapkeys))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(mapkeys) { return { type: mapkeysConstants.GETALL_REQUEST, mapkeys } }
  function success(mapkeys) { return { type: mapkeysConstants.GETALL_SUCCESS, mapkeys } }
  function failure(error) { return { type: mapkeysConstants.GETALL_FAILURE, error } }
}

function updateMapkeys(updateList) {
  return dispatch => {
    dispatch(request())
    mapkeysService.updateMapkeys(updateList)
      .then(
        mapkeys => {
          console.log('mapkeys' + mapkeys)
          if (mapkeys) {
            dispatch(success(mapkeys))
          }
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(mapkeys) { return { type: mapkeysConstants.UPDATE_REQUEST, mapkeys } }
  function success(mapkeys) { return { type: mapkeysConstants.UPDATE_SUCCESS, mapkeys } }
  function failure(error) { return { type: mapkeysConstants.UPDATE_FAILURE, error } }
}
